// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"5c8f00f9","861":"d066df81","924":"ad088dc5"}[chunkId] + ".chunk.css";
};